<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 16px; margin-bottom: 25px;">
      <el-breadcrumb-item>数据转换引擎</el-breadcrumb-item>
      <el-breadcrumb-item>数据转换配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" :model="configSearch">
      <el-form-item>
        <el-select v-model="configSearch.destId" filterable clearable placeholder="请选择推送目标" size="small">
          <el-option v-for="item in destOptions" :key="item.destId" :label="item.destName" :value="item.destId"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查 询</el-button>
        <el-button type="success" size="small" icon="el-icon-plus" @click="handleAdd">新 增</el-button>
      </el-form-item>
    </el-form>

    <!--数据配置列表-->
    <el-table :data="tableData" stripe v-loading="loading" style="width: 100%">
      <el-table-column prop="configName" label="配置名称" width="200px" align="left"/>
      <el-table-column prop="destName" label="推送目标名称" width="150px" align="left"/>
      <el-table-column prop="dataName" label="数据类型" align="left" width="150px"/>
      <el-table-column prop="dataPushType" label="请求类型" align="left" width="80px;"/>
      <el-table-column prop="dataPushUrl" label="推送地址" align="left" width="250px" :show-overflow-tooltip="true"/>
      <el-table-column prop="exchangeConfig" label="转换配置" align="left" :show-overflow-tooltip="true"/>
      <el-table-column prop="description" label="描述" align="left"/>
      <el-table-column label="操作" align="center" width="220px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)" plain>编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)" plain>删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--修改、添加数据转换配置弹出框-->
    <el-dialog :title="title" :visible.sync="open" width="800px" @close="closeDialog" :close-on-click-modal="false">
      <el-form ref="configForm" :model="configForm" :rules="configRules" class="data-type-form">
        <el-row type="flex" justify="start" align="top">
          <el-col :span="10">
            <el-form-item label="推送目标：" prop="destId">
              <el-select v-model="configForm.destId" :disabled="isUpdate" placeholder="请选择推送目标" size="small">
                <el-option v-for="item in destOptions" :key="item.destId" :label="item.destName" :value="item.destId"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请求类型：" prop="dataPushType">
              <el-select v-model="configForm.dataPushType" placeholder="请选请求类型" size="small">
                <el-option key="GET" label="GET" value="GET"/>
                <el-option key="POST" label="POST" value="POST"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="推送地址：" prop="dataPushUrl">
          <el-input v-model="configForm.dataPushUrl" placeholder="请输入推送地址" style="width: 532px;" size="small"/>
        </el-form-item>
        <el-form-item label="数据类型：" prop="dataId">
          <el-radio-group v-model="configForm.dataId" :disabled="isUpdate">
            <el-radio v-for="dataType in dataTypeList" :label="dataType.dataId" :key="dataType.dataId">{{dataType.dataName}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数据配置：" prop="exchangeConfig">
          <vue-json-editor v-model="configForm.exchangeConfig" :show-btns="false" :mode="'code'" lang="zh" />
        </el-form-item>
        <el-form-item label="配置描述：">
          <el-input v-model="configForm.description" type="textarea" placeholder="请输入配置描述信息"
                    :autosize="{minRows: 2, maxRows: 4}" :style="{width: '100%'}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" size="small" @click="handleSaveConfig">保存</el-button>
        <el-button size="small" @click="handleCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueJsonEditor from 'vue-json-editor'
export default {
  data () {
    return {
      loading: false,
      configSearch: {
        destId: null
      },
      configForm: {
        destId: null,
        dataId: null,
        dataPushUrl: null,
        dataPushType: null,
        exchangeConfig: null,
        description: null
      },
      configRules: {
        destId: [{required: true, message: '推送目标不能为空', trigger: 'blur'}],
        dataPushType: [{required: true, message: '请求类型不能为空', trigger: 'blur'}],
        dataPushUrl: [{required: true, message: '推送地址不能为空', trigger: 'blur'}],
        dataId: [{required: true, message: '数据类型不能为空', trigger: 'blur'}],
        exchangeConfig: [{required: true, message: '数据配置不能为空', trigger: 'blur'}]
      },
      destOptions: [],
      title: null,
      open: false,
      // 操作类型
      operType: null,
      tableData: [],
      // 数据类型选项
      dataTypeList: [],
      // 是否为修改
      isUpdate: false
    }
  },
  components: {
    VueJsonEditor
  },
  created () {
    this.getDestSelect()
    this.queryList()
  },
  methods: {
    // 查询推送目标下拉选
    getDestSelect () {
      this.axios.post('/pushDest/queryAll').then(res => {
        if (res.data.code === 200) {
          this.destOptions = res.data.data
        } else {
          this.$message({type: 'error', message: res.data.msg})
        }
      })
    },
    // 查询数据转换配置列表
    queryList () {
      this.axios.post('/dataConfig/queryList', this.configSearch).then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data
        } else {
          this.$message({type: 'error', message: res.data.msg})
        }
      })
    },
    // 点击查询按钮事件
    handleSearch () {
      this.queryList()
    },
    // 点击添加按钮事件
    handleAdd () {
      this.getDataTypeInfo()
      this.open = true
      this.title = '新增数据转换配置'
      this.operType = 1
      this.isUpdate = false
    },
    // 点击修改按钮事件
    handleUpdate (row) {
      this.getDataTypeInfo()
      this.open = true
      this.title = '修改数据转换配置'
      this.configForm.destId = row.destId
      this.configForm.exchangeConfig = JSON.parse(row.exchangeConfig)
      this.configForm.dataId = row.dataId
      this.configForm.dataPushUrl = row.dataPushUrl
      this.configForm.dataPushType = row.dataPushType
      this.configForm.description = row.description
      this.operType = 2
      this.isUpdate = true
    },
    // 点击删除按钮事件
    handleDelete (row) {
      this.$confirm('此操作将永久删除【' + row.destName + '】的数据转换配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.get('/dataConfig/deleteDataConfig/' + row.destId + '/' + row.dataId).then(res => {
          if (res.data.code === 200) {
            this.$message({type: 'success', message: '删除成功!'})
          } else {
            this.$message({type: 'error', message: res.data.msg})
          }
          this.queryList()
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消删除'})
      })
    },
    // 保存数据转换配置
    handleSaveConfig () {
      this.$refs['configForm'].validate(valid => {
        if (valid) {
          let params = {
            destId: this.configForm.destId,
            dataId: this.configForm.dataId,
            dataPushUrl: this.configForm.dataPushUrl,
            dataPushType: this.configForm.dataPushType,
            exchangeConfigNode: this.configForm.exchangeConfig,
            description: this.configForm.description
          }
          if (this.operType === 1) {
            // 新增
            this.axios.post('/dataConfig/addDataConfig', params).then(res => {
              if (res.data.code === 200) {
                this.$message({type: 'success', message: res.data.msg})
                this.restForm()
                this.open = false
                this.queryList()
              } else {
                this.$message({type: 'error', message: res.data.msg})
              }
            })
          } else if (this.operType === 2) {
            // 修改
            this.axios.post('/dataConfig/updateDataConfig', params).then(res => {
              if (res.data.code === 200) {
                this.$message({type: 'success', message: res.data.msg})
                this.restForm()
                this.open = false
                this.queryList()
              } else {
                this.$message({type: 'error', message: res.data.msg})
              }
            })
          }
          this.isUpdate = false
        }
      })
    },
    // 弹出框 X 关闭事件
    closeDialog () {
      this.handleCancel()
    },
    // 弹出框取消按钮点击事件
    handleCancel () {
      this.open = false
      this.restForm()
    },
    // 表单重置
    restForm () {
      this.configForm.destId = null
      this.configForm.exchangeConfig = {}
      this.configForm.dataId = null
      this.configForm.dataPushUrl = null
      this.configForm.dataPushType = null
      this.configForm.description = null
    },
    // 获取数据请求类型check
    getDataTypeInfo () {
      this.axios.get('/dataType/getDataTypeList').then(res => {
        if (res.data.code === 200) {
          this.dataTypeList = res.data.data
        }
      })
    },
    // 数据类型选择
    handleDataTypeChange (value) {
      this.configForm.dataId = value
    }
  }
}
</script>
<style>
.el-table thead {
  color: #1a1a1a !important;
  font-weight:400;
}
.ace-jsoneditor, .ace_editor{
  min-height: 400px !important;
  height: auto !important;
}
.data-type-form .el-form-item{
  margin-bottom: 10px;
}
.el-radio, .el-radio__input{
  line-height: 2 !important;
}
.el-dialog__body {
  padding-bottom: 5px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pageview/DataConfig.vue